import { render, staticRenderFns } from "./LeaveMessagePage.vue?vue&type=template&id=03055ed4&scoped=true&"
import script from "./LeaveMessagePage.vue?vue&type=script&lang=js&"
export * from "./LeaveMessagePage.vue?vue&type=script&lang=js&"
import style0 from "./LeaveMessagePage.vue?vue&type=style&index=0&id=03055ed4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03055ed4",
  null
  
)

export default component.exports